import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn, } from '@angular/forms';
import { datePickerMinDate, convertToNgbDate } from '../../shared/constants';
import { NgSelectModule } from '@ng-select/ng-select';
import { timer } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, filter, take, takeUntil, switchMap, catchError, } from 'rxjs/operators';
import { inject, TemplateRef, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { addDays, isBefore, isSameDay } from 'date-fns';
import { CompanyApptDetailsComponent } from '../company-appt-details/company-appt-details.component';

@Component({
	selector: 'app-company-followup-details',
	templateUrl: './company-followup-details.component.html',
	styleUrls: ['./../company-appt-details/company-appt-details.component.scss', './company-followup-details.component.scss'],
	animations: [
		trigger('fadeInOut', [
			state('void', style({
				opacity: 0
			})),
			transition(':enter, :leave', [
				animate(500)
			])
		])
	]
})
export class CompanyFollowupDetailsComponent implements OnInit {
	uId: any = null;
	followupId: any = null;
	followUpDetails: any = null;
	pageLoading1 = false;
	pageLoading2 = false;
	pageLoading3 = false;
	showOPDFields = false;
	showIPDFields = false;
	showPhysiotherapyFields = false;
	showTeleConsultsFields = false;
	showNonMedicalFields = false;
	labTestList: any[] = [];
	/* followUpBillsData: any[] = []; */
	minDate = datePickerMinDate;
	billingMaxDate = convertToNgbDate(new Date());
	showCompletedFields = false;
	showInProgressFields = false;
	File_Storage_URL = environment.File_Storage_URL;
	amount = 0;
	saveBillLoader = false;
	billFileUploadLoader: any = null;

	followupFiles: any[] = [];
	followupFilesForEdit: any[] = [];
	quillConfig = {
		toolbar: {
			container: [
				['bold', 'italic', 'underline'],
			]
		}
	};
	apptDetailsPath = "";

	showAdmittedFields = false;
	showDayCareFields = false;
	showPreAdmittedFields = false;
	showDischargedFields = false;

	follow_up_date_original: any = null;
	otpFormLoader = false;
	showOTP = false;
	otpFormSubmitted = false;
	otpForm: FormGroup = this.formBuilder.group({
		reason: [null, [Validators.required]],
		otp: [null]
	});
	get f1() { return this.otpForm.controls }
	customErrorOTP: any = {};
	otpMailId: any = "";

	constructor(private toastr: ToastrService, private apiService: ApiService, public formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(CompanyApptDetailsComponent) public parent: CompanyApptDetailsComponent) {
		this.apiService.getFollowUpFilesRefreshEvent().subscribe({
			next: (val) => {
				if (val) {
					this.getFollowUpFiles();
				}
			}
		});
	}

	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.activeRoute.parent?.params.subscribe(parentRouteParams => {
				this.uId = parentRouteParams["uId"];
				this.followupId = routeParams["id"];
				this.activeRoute.parent?.url.forEach((val) => {
					this.apptDetailsPath = val[0].path;
				})
				this.getDetails();
				this.getLabTest();
			});
		})
	}

	getDetails() {
		this.pageLoading1 = true;
		this.apiService.getFollowupDetails(this.followupId).subscribe({
			next: (data: any) => {
				this.pageLoading1 = false;
				this.followUpDetails = data.data;
				/* this.getFolloupBills(); */
				this.getFollowUpFiles();
				this.apptTypeChanged(false);
				this.followupStatusChanged(false);
				this.hospitalizationChanged();
			}, error: (error) => {
				this.pageLoading1 = false;
				this.followUpDetails = null;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	gotoList() {
		this.router.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
			this.router.navigate(['/app/' + this.apptDetailsPath, this.uId, this.followupId]);
		});
	}

	getHospitalizationName() {
		let len = this.parent.hospStatusList.length;
		for (let i = 0; i < len; i++) {
			if (this.parent.hospStatusList[i].id == this.followUpDetails?.hospitalization_status) {
				return this.parent.hospStatusList[i].name;
			}
		}
		return "";
	}

	getSurgeryStatusName() {
		let len = this.parent.surgeryStatusList.length;
		for (let i = 0; i < len; i++) {
			if (this.parent.surgeryStatusList[i].id == this.followUpDetails?.surgery_status) {
				return this.parent.surgeryStatusList[i].name;
			}
		}
		return "";
	}

	getLabtestNames() {
		let len = this.labTestList.length;
		let len1 = this.followUpDetails?.lab_test?.length;
		let names: string[] = [];
		for (let i = 0; i < len; i++) {
			for (let j = 0; j < len1; j++) {
				if (this.labTestList[i].id == this.followUpDetails?.lab_test[j]) {
					names.push(this.labTestList[i].name);
				}
			}
		}
		return names.join(", ");
	}

	apptTypeChanged(calledByUser: boolean) {
		let val = this.followUpDetails.visit_type?.id;
		if (val == 1) {
			/* OPD */
			this.showOPDFields = true;
			this.showIPDFields = false;
			this.showPhysiotherapyFields = false;
			this.showTeleConsultsFields = false;
			this.showNonMedicalFields = false;
			this.clearPhysiotherapyFields();
			this.clearIPDFields();
			this.clearTeleConsultsFields();
			this.clearNonMedicalFields();
		} else if (val == 2) {
			/* IPD */
			this.showOPDFields = false;
			this.showIPDFields = true;
			this.showPhysiotherapyFields = false;
			this.showTeleConsultsFields = false;
			this.showNonMedicalFields = false;
			this.clearOPDFields();
			this.clearPhysiotherapyFields();
			this.clearTeleConsultsFields();
			this.clearNonMedicalFields();
		} else if (val == 3) {
			/* Physiotherapy */
			this.showOPDFields = false;
			this.showIPDFields = false;
			this.showPhysiotherapyFields = true;
			this.showTeleConsultsFields = false;
			this.showNonMedicalFields = false;
			this.clearOPDFields();
			this.clearIPDFields();
			this.clearTeleConsultsFields();
			this.clearNonMedicalFields();
		} else if (val == 4) {
			/* Tele-Consult */
			this.showOPDFields = false;
			this.showIPDFields = false;
			this.showPhysiotherapyFields = false;
			this.showTeleConsultsFields = true;
			this.showNonMedicalFields = false;
			this.clearOPDFields();
			this.clearIPDFields();
			this.clearPhysiotherapyFields();
			this.clearNonMedicalFields();

			this.clearNonTeleConsultsFields();
		} else if (val == 5) {
			/* Non Medical */
			this.showOPDFields = false;
			this.showIPDFields = false;
			this.showPhysiotherapyFields = false;
			this.showTeleConsultsFields = false;
			this.showNonMedicalFields = true;
			this.clearOPDFields();
			this.clearIPDFields();
			this.clearPhysiotherapyFields();
			this.clearTeleConsultsFields();

			this.clearNonNonMedicalFields();
		} else {
			this.showOPDFields = false;
			this.showIPDFields = false;
			this.showPhysiotherapyFields = false;
			this.showTeleConsultsFields = false;
			this.showNonMedicalFields = false;
			this.clearOPDFields();
			this.clearIPDFields();
			this.clearPhysiotherapyFields();
			this.clearTeleConsultsFields();
			this.clearNonMedicalFields();
		}
	}

	clearOPDFields() {
	}

	clearIPDFields() {
		this.hospitalizationChanged();
	}

	clearPhysiotherapyFields() {
	}

	clearTeleConsultsFields() {
	}

	clearNonMedicalFields() {
	}

	clearNonTeleConsultsFields() {
	}

	clearNonNonMedicalFields() {
	}

	hospitalizationChanged() {
		let val = this.followUpDetails.hospitalization_status;
		if (val == 4) {
			/* Admitted */
			this.showAdmittedFields = true;
			this.showPreAdmittedFields = false;
			this.showDischargedFields = false;
			this.showDayCareFields = false;
			this.clearPreAdmittedFields();
			this.clearDischargedFields();
			this.clearDayCareFields();
		} else if (val == 28) {
			/* Daycare Procedure */
			this.showAdmittedFields = false;
			this.showPreAdmittedFields = false;
			this.showDischargedFields = false;
			this.showDayCareFields = true;
			this.clearAdmittedFields();
			this.clearPreAdmittedFields();
			this.clearDischargedFields();

			this.clearNonDischargedFields();
		} else if (val == 6) {
			/* Preadmission */
			this.showAdmittedFields = false;
			this.showPreAdmittedFields = true;
			this.showDischargedFields = false;
			this.showDayCareFields = false;
			this.clearAdmittedFields();
			this.clearDayCareFields();
			this.clearDischargedFields();
		} else if (val == 5) {
			/* Discharged */
			this.showAdmittedFields = false;
			this.showPreAdmittedFields = false;
			this.showDischargedFields = true;
			this.showDayCareFields = false;
			this.clearAdmittedFields();
			this.clearDayCareFields();
			this.clearPreAdmittedFields();

			this.clearNonDischargedFields();
		} else {
			this.showAdmittedFields = false;
			this.showPreAdmittedFields = false;
			this.showDischargedFields = false;
			this.showDayCareFields = false;
			this.clearAdmittedFields();
			this.clearPreAdmittedFields();
			this.clearDischargedFields();
			this.clearDayCareFields();
		}
	}

	clearAdmittedFields() {
	}

	clearDayCareFields() {
	}

	clearPreAdmittedFields() {
	}

	clearDischargedFields() {
	}

	clearNonDischargedFields() {
	}

	followupStatusChanged(isChangedByUser: boolean) {
		let val = this.followUpDetails.follow_up_status?.id;
		if (val === 1) {
			this.showInProgressFields = true;
			this.showCompletedFields = false;
		} else if (val === 2) {
			this.showInProgressFields = false;
			if (isChangedByUser) {
				this.showCompletedFields = true;
			}
			this.clearInProgressFields();
		} else {
			this.showInProgressFields = false;
			this.showCompletedFields = false;
			this.clearInProgressFields();
		}
	}

	clearInProgressFields() { }

	getLabTest() {
		this.apiService.getLabTest({}).subscribe({
			next: (data: any) => {
				this.labTestList = data.data;
			}, error: (error) => {
				this.labTestList = [];
			},
		});
	}

	getFileName(path: string) {
		try {
			return path.split("/").pop() || "";
		} catch (error) {
			return path;
		}
	}

	getFollowUpFiles() {
		this.pageLoading3 = true;
		this.apiService.getFollowUpFiles({ id: this.followUpDetails.id }).subscribe({
			next: (data: any) => {
				data.data.map((bill: any) => {
					bill.file_url = bill.file_url === null ? [] : bill.file_url;
					return bill
				});
				this.pageLoading3 = false;
				this.followupFiles = data.data;
			}, error: (error) => {
				this.pageLoading3 = false;
				this.followupFiles = [];
			}
		})
	}
}
